<template>
  <div name="demo-table-add-inline">
    <hrms-table :columns="columns[nowLang].index"
                :data="index"
                :maxRowspan="maxRowspan"
                :addInlineEventBool="true"
                :editInlineEventBool="true"
                :deleteInlineEventBool="true"
                :saveInlineEvent="showFlgDetails"
                :columnEvent="columnEvent" />

    <div class="col-xs-12 col-md-6">
      <div class="form-group-button">
        <div class="btn button-in-search bg-dark-gray" @click="refresh()"><i class="fa fa-refresh"></i>Refresh</div>
      </div>
    </div>

    <template v-if="objs.add.rows.length > 0">
      <h3>{{desc.add}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.add"
                  :maxRowspan="maxRowspan" />
    </template>
    <template v-if="objs.edit.rows.length > 0">
      <h3>{{desc.edit}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.edit"
                  :maxRowspan="maxRowspan" />
    </template>
    <template v-if="objs.delete.rows.length > 0">
      <h3>{{desc.delete}}</h3>
      <hrms-table :columns="columns[nowLang].index"
                  :data="objs.delete"
                  :maxRowspan="maxRowspan" />
    </template>
  </div>
</template>

<script>
import faker from 'faker'
import _ from 'lodash'
import moment from 'moment'
import mock from './mockTableData.js'

let labels = mock.inlineLabels
let flgRowCondition = false
let mockColumns = mock.columns(labels, 'validate', flgRowCondition)
let mockMaxRowspan = 2
let mockData = mock.dataInline(flgRowCondition)

export default {
  name: 'demo-table-add-inline',
  data () {
    return {
      nowLang: 'en',
      columns: {
        en: { index: mockColumns },
        th: { index: mockColumns }
      },
      index: mockData,
      maxRowspan: mockMaxRowspan,
      objs: {
        add: {
          total: 0,
          rows: []
        },
        edit: {
          total: 0,
          rows: []
        },
        delete: {
          total: 0,
          rows: []
        }
      },
      desc: {
        add: '',
        edit: '',
        delete: ''
      }
    }
  },
  methods: {
    refresh () {
      this.index = mockData
    },
    columnEvent (eventName, param) {
      switch (eventName) {
        case 'dtework':
          param.dtework = moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year()
          param.typwork = faker.address.stateAbbr()
          param.codshift = faker.address.stateAbbr()
          param.codreqst = faker.random.number().toString().substr(0, 4)
          param.qtylate = faker.date.past().toString().substr(16, 5)
          param.qtyearly = faker.date.past().toString().substr(16, 5)
          param.qtyabsent = faker.date.past().toString().substr(16, 5)
          param.desc_staappr = faker.lorem.word()
          break
        case 'dtein':
          param.dteout = moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year()
          break
        case 'dteout':
          param.dtein = moment().daysInMonth() + '/' + _.padStart(moment().month() + 1, 2, '0') + '/' + moment().year()
          break
        case 'codreqst':
          param.remark = faker.lorem.word()
          break
        case 'timin':
          param.timout = faker.date.past().toString().substr(16, 5)
          break
        case 'timout':
          param.timin = faker.date.past().toString().substr(16, 5)
          break
      }
    },
    showFlgDetails (params) {
      var inlineObjs = [{
        flg: 'add',
        desc: 'added'
      }, {
        flg: 'edit',
        desc: 'edited'
      }, {
        flg: 'delete',
        desc: 'deleted'
      }]
      for (var inlineObj of inlineObjs) {
        var dataRows = params.filter(function (paramRow) {
          return paramRow.flg === inlineObj.flg
        })
        this.objs[inlineObj.flg].total = dataRows.length
        this.objs[inlineObj.flg].rows = dataRows
        var total = dataRows.length
        if (total <= 1) {
          this.desc[inlineObj.flg] = 'Data is ' + inlineObj.desc + ' ' + total + ' row'
        } else {
          this.desc[inlineObj.flg] = 'Data are ' + inlineObj.desc + ' ' + total + ' rows'
        }
      }
    }
  }
}
</script>


// WEBPACK FOOTER //
// demoTableInline.vue?f52ba53a